import Image from "next/image";
import React, { useEffect, useState } from "react";
import Style from "./style.module.scss";

interface ReviewSlideProps {
  data?: any;
  variant?: "blue" | "green";
}

const ReviewSlide: React.FC< ReviewSlideProps> = ({ data,
  variant = "blue",
 }) => {
  const { reviewTitle, text, Rating, author, AutherPosition } = data;

  const bgColor = variant === "green" ? "bg-green-50" : "bg-blue-50";
  const bgBorder = variant === "green" ? "border-green-100" : "border-border";

  const [animateTitle, setAnimateTitle] = useState(false);

  // Re-trigger animation on data change
  useEffect(() => {
    setAnimateTitle(false);
    const timer = setTimeout(() => setAnimateTitle(true), 10);
    return () => clearTimeout(timer);
  }, [data]);

  return (
    <div
      className={`${bgColor} border ${bgBorder} overflow-hidden h-full review-main-card`}
    >
      <div className={`gap-[6px] review_head border-b-0 !bg-white ${bgBorder}`}>
        <div className="flex md:mt-0 mt-2 mb-[12px] lx-mt w-full md:w-auto items-center gap-1">
          {[...Array(5)].map((_, i) => (
            <Image
              key={i}
              src="/images/ServicesPage/Star.svg"
              alt="Star"
              width={28}
              height={28}
              className={i < Rating ? "opacity-100" : "opacity-30"}
            />
          ))}
        </div>
        <div className={`w-fit`}>
          <div className="xl:mr-2 lg:mr-4">
            <p
              className={`${
                animateTitle ? Style["title-animation"] : ""
              } font-bold text-[20px] md:text-[24px] md:leading-[31.2px] text-primary-text  leading-[30px] line-clamp-3 md:min-h-[40px] min-h-[70px] text-overflow-ellipsis`}
            >
              {reviewTitle ?? ""}
            </p>
          </div>
        </div>
      </div>

      <div
        className={`bg-white px-8 py-0 review_content min-h-[300px] lg:min-h-[250px] xl:min-h-[170px]`}
      >
        <p
          className={`${
            animateTitle ? Style["title-animation"] : ""
          } title-animation text-black font-semibold text-subtitle-2 line-clamp-12 text-overflow-hidden`}
        >
          {text ?? ""}
        </p>
      </div>

      <div className={`bg-white`}>
        <div className={`mx-8 py-6 review_footer border-t ${bgBorder}`}>
          <div
            className={`text-right flex flex-col justify-end w-full ${Style.ThemeBody}`}
          >
            <p className="font-semibold text-subtitle-1">{author}</p>
            <span className="text-subtitle-5 font-regular mt-1">
              {AutherPosition ?? ""}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ReviewSlide;